import {parsePhoneNumber} from "libphonenumber-js";
import {getNumberType} from "libphonenumber-js/custom";
import metadata from "libphonenumber-js/metadata.full.json";
import {minLength} from "admin-on-rest";

export const validateAdminDataCreate = (values, {translate}) => {
  const errors = {};
  if (!values.email || values.email.trim() === "") {
    errors.email = translate("resources.admins.validation.email");
  }

  if (!values.phone || values.phone.trim() === "") {
    errors.phone = translate("resources.admins.validation.phoneRequired");
  }

  if (!values.password || values.password.trim() === "") {
    errors.password = translate("resources.admins.validation.password");
  }
  if (!values.password2 || values.password2.trim() === "") {
    errors.password2 = translate(
      "resources.admins.validation.repeatPassword"
    );
  }
  if (values.password && !values.password2) {
    errors.password2 = translate(
      "resources.admins.validation.repeatPassword"
    );
  }
  if (!values.password && values.password2) {
    errors.password = translate("resources.admins.validation.password");
  }
  if (
    values.password &&
    values.password2 &&
    values.password !== values.password2
  ) {
    errors.password = translate(
      "resources.admins.validation.matchPasswords"
    );
    errors.password2 = translate(
      "resources.admins.validation.matchPasswords"
    );
  }

  return errors;
};

export const validatePassword = [minLength(6)];

export const validatePhone = (value, allValues, props) => {
  if (value) {
    try {
      return parsePhoneNumber(value, "SE").isValid() &&
        parsePhoneNumber(value, "SE").isPossible() &&
        getNumberType(value, metadata) === "MOBILE"
        ? undefined
        : props.translate("resources.admins.validation.phone");
    } catch (error) {
      return props.translate("resources.admins.validation.phone");
    }
  }
};

export const validateAdminDataEdit = (values, {translate}) => {
  const errors = {};
  if (!values.email || values.email.trim() === "") {
    errors.email = translate("resources.admins.validation.email");
  }
  if (!values.phone || values.phone.trim() === "") {
    errors.phone = translate("resources.admins.validation.phoneRequired");
  }

  if (values.password && !values.password2) {
    errors.password2 = translate(
      "resources.admins.validation.repeatPassword"
    );
  }
  if (!values.password && values.password2) {
    errors.password = translate("resources.admins.validation.password");
  }
  if (
    values.password &&
    values.password2 &&
    values.password !== values.password2
  ) {
    errors.password = translate(
      "resources.admins.validation.matchPasswords"
    );
    errors.password2 = translate(
      "resources.admins.validation.matchPasswords"
    );
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/containers/CRM/Admins/validations.js